import { createContext, use } from "react";
import { defined } from "../utilities/typeHelper";

interface NotificationContextType {
  notification?: Notification;
  notificationError?: Notification;
  sendNotification: (text: string, autoHideDuration?: number) => void;
  sendNotificationError: (text: string, autoHideDuration?: number) => void;
  onCloseNotification: () => void;
  onCloseNotificationError: () => void;
}

export interface Notification {
  text: string;
  autoHideDuration: number;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotificationContext = () => {
  const client = use(NotificationContext);
  return defined(client);
};
